import { LOGIN, LOGOUT } from './mutation-types'

export default {
  [LOGIN](state, payload) {
    state.Nome = payload.Nome
    state.userName = payload.userName
    state.access_token = payload.access_token
    state.refresh_token = payload.refresh_token
    state.expires_in = payload.expires_in
    state.expires = payload['.expires']
  },

  [LOGOUT](state) {
    state.Nome = ''
    state.userName = ''
    state.access_token = ''
    state.refresh_token = ''
    state.expires_in = ''
    state.expires = ''
  }
}
